export default {
  redirect(to, params = {}) {
    console.log('helper redirect');
    location.href = '#/'.to;
  },
  replace(text, data) {
    let link = `${text}`;
    Object.keys(data).forEach((key) => {
      const v = data[key];
      link = link.replace(new RegExp('{' + key + '}', 'g'), v);
    });
    return link;
  },
};
